import keys from '../../../../config/keys';

export default {
  '8': keys.BACK,
  '461': keys.BACK,
  '13': keys.ENTER,
  '0': keys.EXIT,

  '37': keys.LEFT,
  '38': keys.UP,
  '39': keys.RIGHT,
  '40': keys.DOWN,

  '83': keys.CH_UP, //s
  '68': keys.CH_DOWN, //d

  // Color
  '27': keys.RED,
  '112': keys.GREEN,
  '113': keys.YELLOW,
  '114': keys.BLUE,

  // Playback
  '415': keys.PLAY,
  '180': keys.PAUSE,
  '227': keys.RW,
  '228': keys.FF,
  '81': keys.STOP, //q

  // Numeric
  '49': keys.ONE,
  '50': keys.TWO,
  '51': keys.THREE,
  '52': keys.FOUR,
  '53': keys.FIVE,
  '54': keys.SIX,
  '55': keys.SEVEN,
  '56': keys.EIGHT,
  '57': keys.NINE,
  '48': keys.ZERO,
};
